(function () {

    'use strict';

    angular.module('asys')
        .controller('ModalPdfViewerController', ModalPdfViewerController);

    ModalPdfViewerController.$inject = [
        '$log',
        '$window',
        '$modalInstance',
        '$timeout',
        'lodash',
        'modernizr',
        'AppConfig',
        'MiscUtilsService',
        'DeviceUtilsService',
        'mediaQueries',
        'pdf'
    ];

    function ModalPdfViewerController($log, $window, $modalInstance, $timeout, _, modernizr, AppConfig, MiscUtilsService, DeviceUtilsService, mediaQueries, pdf) {
        var vm = this,
            pdfViewerOptions = AppConfig.APP.pdfviewer.options,
            pdfJsViewerUrl = AppConfig.APP.pdfviewer.url;

        $log.debug('ModalPdfViewerController', vm);

        activate();

        vm.onClose = onClose;

        function activate() {
            vm.appModus = MiscUtilsService.isAppModus();
            vm.pdfUrl = AppConfig.ANGEBOT.waitHelperUrl;
            vm.onPdfIframeLoaded = onPdfIframeLoaded;

            if (!(mediaQueries.medium() && mediaQueries.large())) {
                pdfViewerOptions = _.reject(pdfViewerOptions, function (val) {
                    return val === 'pagemode=thumbs';
                });
                pdfViewerOptions.push('pagemode=none');
            }

            pdf.promise.then(function (pdfFile) {
                vm.pdfUrl = [
                    pdfJsViewerUrl,
                    '?file=',
                    pdfFile.url,
                    pdfViewerOptions ? '#' + pdfViewerOptions.join('&') : ''
                ].join('');

                vm.pdf = pdfFile;
            }).catch(function () {
                $modalInstance.close();
            });
        }

        function onClose() {
            $modalInstance.close();
        }

        function onPdfIframeLoaded(element) {
            $timeout(function () {
                if (!element || !element[0] || !element[0].contentDocument || !modernizr.classlist) {
                    return;
                }

                var browser,
                    printIconElement = element[0].contentDocument.getElementById('print'),
                    secondaryPrintIconElement = element[0].contentDocument.getElementById('secondaryPrint'),
                    openFileElement = element[0].contentDocument.getElementById('openFile'),
                    secondaryOpenFileElement = element[0].contentDocument.getElementById('secondaryOpenFile'),
                    editorStampElement = element[0].contentDocument.getElementById('editorStamp'),
                    downloadElement = element[0].contentDocument.getElementById('download'),
                    secondaryDownloadElement = element[0].contentDocument.getElementById('secondaryDownload');

                browser = DeviceUtilsService.getBowser();

                if (browser.mobile || browser.tablet || browser.android || browser.ios || (browser.mac && $window.navigator.maxTouchPoints > 2)) {
                    if (printIconElement) {
                        printIconElement.classList.add('hidden');
                    }

                    if (secondaryPrintIconElement) {
                        secondaryPrintIconElement.classList.add('hidden');
                    }
                }

                if (openFileElement) {
                    openFileElement.classList.add('hidden');
                }

                if (secondaryOpenFileElement) {
                    secondaryOpenFileElement.classList.add('hidden');
                }

                if (editorStampElement) {
                    editorStampElement.classList.add('hidden');
                }

                if (vm.appModus) {
                    if (downloadElement) {
                        downloadElement.classList.add('hidden');
                    }

                    if (secondaryDownloadElement) {
                        secondaryDownloadElement.classList.add('hidden');
                    }
                }
            }, 500);
        }
    }

})();
